import React from 'react';
import { Switch } from '@headlessui/react';
// import { aplicarMascara } from "../../utils/mascaraTelefone";

interface TelefoneHeaderProps {
  onRinging: boolean;
  isLogged: boolean;
  onCall: boolean;
  phoneNumber: string;
  onChangeHandler(): void;
  isHibrido?: boolean
}

export function TelefoneHeader({ onRinging, onCall, phoneNumber, isLogged, onChangeHandler, isHibrido }: TelefoneHeaderProps) {
  function renderPhoneNumber() {
    if (onRinging) {
      return <h4>Ligando para: {phoneNumber}</h4>;
    } else if (onCall) {
      return <h4>Em ligação: {phoneNumber}</h4>;
    } else {
      return <h4>{phoneNumber}</h4>;
    }
  }

  return (
    <>
      <div className={`mt-4 flex w-full select-none flex-col items-center rounded p-3 text-primary ${isHibrido && 'hidden'}`}>
        <Switch.Group>
          <div className="flex items-center">
            <Switch.Label className="ml-4 select-none px-4 text-blue-900">Login Discador: &nbsp;</Switch.Label>
            <Switch
              disabled={onRinging || onCall}
              checked={isLogged}
              onChange={onChangeHandler}
              className={`${isLogged ? 'bg-primary' : 'bg-gray-200'
                } relative inline-flex h-6 w-11 select-none items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2`}
            >
              <span
                className={`${isLogged ? 'translate-x-6' : 'translate-x-1'
                  } inline-block h-4 w-4 transform select-none rounded-full bg-white transition-transform`}
              />
            </Switch>
          </div>
        </Switch.Group>
      </div>
      <div className="flex h-12 w-full select-none flex-col items-center rounded bg-gray-200 p-3 text-primary">
        {renderPhoneNumber()}
      </div>
    </>
  );
}
